import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EasTableColumn } from '@fry/lib/store';
import { objectIdentifier } from '@fry/lib/utils';


@Component({
    selector: 'eas-columns-selector',
    templateUrl: './columns-selector.component.html',
    styleUrls: ['./columns-selector.component.css', '../table-controls.common.css'],
    standalone: false
})
export class ColumnsSelectorComponent {
  @Input() defaultColumns: string[] = [];
  @Input() allAvailable: EasTableColumn[] = [];
  allAvailableGrouped: { [key: string]: EasTableColumn[] } = {};
  groupCount: number = 0;

  @Input() selected: string[] = [];
  _selected: string[] = [];

  // We need these for ARIA attributes
  _id = objectIdentifier('rsr-');
  // We'll make sure these are unique by appending the index in the ngFor
  panelId = `column-panel-${this._id}-`;
  buttonId = `column-button-${this._id}-`;

  @Output() selectedApplied = new EventEmitter<string[]>();

  searchText: string = '';

  ngOnInit(): void {
    // only keep the one that is in allAvailable
    this._selected = this.selected.filter((id) => this.allAvailable.find((col) => col.id === id));

    // group allAvailable by group: format is {id: string, label: string, group: string} => {groupX: [{}], groupY: [{}]}
    this.allAvailableGrouped = this.allAvailable.reduce((acc, item) => {
      const { group = 'Ungrouped', id, label } = item;

      if (!acc[group]) {
        acc[group] = [];
      }

      acc[group].push({ id, label });

      return acc;
    }, {} as Record<string, EasTableColumn[]>);

    this.groupCount = Object.keys(this.allAvailableGrouped).length;
  }

  countSelectedColumns(columns: EasTableColumn[]): number {
    return columns.filter((column) => this.isSelected(column.id)).length;
  }

  isSelected(id: string): boolean {
    return this._selected.includes(id);
  }

  // Select or deselect column
  onSelected(id: string): void {
    const index = this._selected.indexOf(id);
    if (index >= 0) {
      this._selected.splice(index, 1);
    } else {
      this._selected.push(id);
    }
    this.onSelectedApplied();
  }

  onSelectedApplied(): void {
    this.selectedApplied.emit(this._selected);
  }

  selectAllInGroup(columns: EasTableColumn[]) {
    const notSelected = columns.filter((column) => !this.isSelected(column.id));
    this._selected.push(...notSelected.map((column) => column.id));
    this.onSelectedApplied();
  }

  deselectAllInGroup(columns: EasTableColumn[]) {
    this._selected = this._selected.filter((id) => !columns.find((column) => column.id === id));
    this.onSelectedApplied();
  }

  onResetToDefault(): void {
    this.selectedApplied.emit(this.defaultColumns);
  }
}
